export default function PrevIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9987 36.6663C29.2034 36.6663 36.6654 29.2044 36.6654 19.9997C36.6654 10.7949 29.2034 3.33301 19.9987 3.33301C10.794 3.33301 3.33203 10.7949 3.33203 19.9997C3.33203 29.2044 10.794 36.6663 19.9987 36.6663Z"
        fill="currentColor"
      />
      <path
        d="M22.5 26.6663C22.5 26.6663 17.5 21.7563 17.5 19.9997C17.5 18.2428 22.5 13.333 22.5 13.333"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
